/**
 * Converts a hex color to rgba format with specified alpha
 * @param {string} hex - Hex color (#fff, #ffffff, #ffffffff)
 * @param {number} alpha - Alpha value (0-1)
 * @returns {string} rgba color string
 */
export const hexToRgba = (hex, alpha = 1) => {
  if (!hex || typeof hex !== "string") return `rgba(0, 0, 0, ${alpha})`;

  const value = hex.trim();

  if (!value.startsWith("#")) {
    return value.startsWith("rgba") ? value : `rgba(0, 0, 0, ${alpha})`;
  }

  const cleanHex = value.slice(1);

  if (cleanHex.length === 3) {
    const r = parseInt(cleanHex[0] + cleanHex[0], 16);
    const g = parseInt(cleanHex[1] + cleanHex[1], 16);
    const b = parseInt(cleanHex[2] + cleanHex[2], 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  if (cleanHex.length === 6) {
    const r = parseInt(cleanHex.slice(0, 2), 16);
    const g = parseInt(cleanHex.slice(2, 4), 16);
    const b = parseInt(cleanHex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return `rgba(0, 0, 0, ${alpha})`;
};